export default __webpack_public_path__ + "static/media/grafema_design-factory-kitchen-pictograms_02.d1fcb102.jpg";